$(document).on('click', '#CartDrawer-Checkout', function(event) {
  $('#cart').submit();
});

function carthtmldata(cart){
  $.ajax({
    type: 'GET', 
    url: '/',
    dataType: 'html',
    success: function(cart_html) {
      var cartdrawer_content = $(cart_html).find('#my-sidebar-cart').html();
      $('#my-sidebar-cart').html(cartdrawer_content);
      var cart_count = $(cart_html).find('.sticky-header-cart-count .cart-count-number, .cart-count .cart-count-number').html();
      $('.sticky-header-cart-count .cart-count-number, .cart-count .cart-count-number').html(cart_count);
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
    }
  });
}

// document.addEventListener('launchtip_add_to_cart', function() {
//     carthtmldata();

// });

// document.addEventListener('LaunchTipAddToCartForm', function() {
//     carthtmldata();
// });

  $(document).on('click', '.upsell-btn', function(event){
  event.preventDefault();
    console.log('cc');
   var id = $(this).parents('.pro-list-content').find('[name="id"]').val();
    var data = JSON.stringify({
        items: [
          {
            id: id,
            quantity: 1
          }
        ],
        sections: "custom-cart-drawer"
      });
    // console.log(data);
    addToCart(data);
});


function qunatityChange(line, qty){
fetch('/cart/change', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify({
    line: line,
    quantity: qty,
    sections: ["custom-cart-drawer"],
    sections_url: "/"
  })
})
.then(response => response.json())
.then(cart => {
const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
$('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
 $('.sticky-header-cart-count .cart-count-number, .cart-count .cart-count-number').html(cart.item_count);
})
.catch(error => {
  console.error('Error:',error);
});
}
function addToCart(data) {
  // console.log(data);
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: data
    })
    .then(response => {
console.log(response);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(cart => {
        console.log(cart);

        // Hide upsell modal and overlay
        document.querySelector('[data-modal="upsell"]').style.display = 'none';
        document.querySelector('.subscription-upsell-overlay').style.display = 'none';

        // Check if the custom cart drawer section exists
        if (cart.sections && cart.sections['custom-cart-drawer']) {
            const parser = new DOMParser();
            const html = parser.parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
            document.querySelector('#my-sidebar-cart').innerHTML = 
                html.querySelector('#my-sidebar-cart').innerHTML;
        } else {
            console.error('Section custom-cart-drawer is missing in the response');
        }

        // Update cart count
        fetch('/cart.js')
            .then(response => response.json())
            .then(cartData => {
                document.querySelectorAll('.sticky-header-cart-count .cart-count-number, .cart-count .cart-count-number')
                    .forEach(el => el.textContent = cartData.item_count);
            });

        // Open cart drawer
        document.querySelector('.cart-drawer').classList.add('open_cartdrawer');
        document.body.classList.add('js-drawer-open');
        document.querySelector('.cart-overlay').style.display = 'block';
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

// function addToCart(data){
// fetch('/cart/add', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json',
//     'Accept': 'application/json'
//   },
//   body: data,
  
// })
// .then(response => response.json())
// .then(cart => {
//   console.log(cart);
//   $('[data-modal="upsell"]').hide();
//   $('.subscription-upsell-overlay').hide();
//   const html = new DOMParser().parseFromString(cart.sections['custom-cart-drawer'], 'text/html');
//   $('#my-sidebar-cart').html($(html).find('#my-sidebar-cart').html());
//   $.getJSON('/cart.js', function(cartData) {
//     $('.sticky-header-cart-count .cart-count-number, .cart-count .cart-count-number').html(cartData.item_count);
//   });
//   $('.cart-drawer').addClass('open_cartdrawer');
//       $('body').addClass('js-drawer-open');
//       $('.cart-overlay').show();
// })
// .catch(error => {
//   console.error('Error:',error);
// });
// }
 $(document).on('click', '.event_continue_shopping', function(event){
  event.preventDefault();
    console.log('cc');
   var variantCid = $(this).parents('.subscription-upsell-modal').find('.event-bundle-atc').attr('data-variant-id');
   var crossQuantity = $(this).parents('.subscription-upsell-modal').find('.event-bundle-atc').attr('data-qty');
    var data = JSON.stringify({
        items: [
          {
            id: variantCid,
            quantity: crossQuantity
          }
        ],
        sections: "custom-cart-drawer"
      });
    // console.log(data);
   
    addToCart(data);
});

$(document).on('click', '.event-bundle-atc', function(event){
  event.preventDefault();
    const variantId1 = $(this).attr('data-variant-crossid');
    const quantity1 = $(this).attr('data-crossqty');

    const variantId2 = $(this).attr('data-variant-id');
    const quantity2 = $(this).attr('data-qty');

    // Create items array with dynamic IDs and quantities
    const items = [
        { id: variantId1, quantity: quantity1 },
        { id: variantId2, quantity: quantity2 }
    ];

  var data = JSON.stringify({
        items: items,
        sections: "custom-cart-drawer"
      });
    // console.log(data);
   
    addToCart(data);

});



$(document).on('change', '.select-variant', function(){
	var available = $(this).find('option:selected').attr('data-available');
if(available == 'false'){
$(this).parents('.why-not-pro-list').find('.upsell-btn').attr('disabled', 'disabled');
$(this).parents('.why-not-pro-list').find('.upsell-btn .btn__text').html('Sold');
}else{
$(this).parents('.why-not-pro-list').find('.upsell-btn').removeAttr('disabled', 'disabled');
$(this).parents('.why-not-pro-list').find('.upsell-btn .btn__text').html('Add');
}
});
function drawerPlus(item) {
  var qty = parseInt($(item).prev().val());
  var line = $(item).attr('data-index');
  qty += 1;
  qunatityChange(line, qty);
}
function drawerMinus(item) {
  var qty = parseInt($(item).next().val());
  var line = $(item).attr('data-index');
  qty -= 1;
  qunatityChange(line, qty);
}
function drawerInputitem(item) {
  var qty = parseInt($(item).val());
  var line = $(item).attr('data-index');
  qunatityChange(line, qty);
}
function drawerRemove(item) {
  var line = $(item).attr('data-index');
  qunatityChange(line, 0);
}
$(document).on('click', '.sticky-header-cart-count, .cart-count', function(event) {
  event.preventDefault(); 
 $('.cart-drawer').addClass('open_cartdrawer');
  $('body').addClass('js-drawer-open');
  $('.cart-overlay').show();
});
$(document).on("click", "[data-action='close-drawer']", function (e) {
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $('.cart-overlay').hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});
$(document).on("click", ".cart-overlay", function (e) {
  e.preventDefault();
  $('.cart-drawer').removeClass('open_cartdrawer');
  $('body').removeClass('js-drawer-open');
  $(this).hide();
  $('.PageOverlay').removeClass('is-visible');
  $('html').removeClass('no-scroll');
});


//  $(document).on('click', '.shopify-product-form .add-to-cart', function(event){
//   event.preventDefault();
//   alert();
//    var id = $(this).parents('.shopify-product-form').find('[name="id"]').val();
//     var data = JSON.stringify({
//         items: [
//           {
//             id: id,
//             quantity: 1
//           }
//         ],
//         sections: "custom-cart-drawer"
//       });
//     console.log(data);
   
//     addToCart(data);
// });
